// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./img/background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* || VARIABLES */

:root {
    /* COLORS */
    --BGCOLOR: #0F172A;
    --BORDER-COLOR: #FFF;
    --COLOR: #FFF;
    --ERROR: firebrick;
    --INACTIVE: lightgray;
    --LINK-COLOR: whitesmoke;
    --LINK-HOVER: rgba(245, 245, 245, 0.9);
    --NOTE-BGCOLOR: hsla(240, 64%, 27%, 0.65);
    --STATUS-COMPLETE: limegreen;
    --STATUS-OPEN: firebrick;
    --TABLE-BGCOLOR: #FFF;
    --TABLE-COLOR: #000;
    --INPUT-INVALID: #F00;
}

/* || UTILITY CLASSES */
.errmsg {
    display: inline-block;
    background-color: var(--TABLE-BGCOLOR);
    color: var(--ERROR);
    padding: 0.25em;
    margin-bottom: 0.5em;
}

.errmsg a:any-link {
    color: var(--ERROR);
    text-decoration: underline;
}

.nowrap {
    white-space: nowrap;
}

.icon-button {
    width: 48px;
    height: 48px;
    font-size: 2.4rem;
    background-color: transparent;
    border: none;
    color: var(--COLOR);
    display: inline;
    place-content: center;
}

.icon-button:hover,
.icon-button:focus-visible {
    transform: scale(1.2);
}

.icon-button[disabled] {
    visibility: hidden;
}

/* || GENERAL STYLES */

body {
    font-family: 'Nunito', sans-serif;
    min-height: 100vh;
    background-color: var(--BGCOLOR);
    color: var(--COLOR);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: top right;
    background-blend-mode: multiply;
}

input,
button,
textarea,
select {
    font: inherit;
}

#root {
    /* React root div */
    min-height: 100vh;
    display: flex;
    flex-flow: column nowrap;
}

a {
    text-decoration: none;
}

a:any-link {
    color: var(--LINK-COLOR);
}

a:hover,
a:focus-visible {
    color: var(--LINK-HOVER);
}

/* || PAGES */

.public,
.welcome {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.public {
    padding: 1em;
    flex-grow: 1;
}

.public__main,
.login {
    flex-grow: 1;
    border-top: 2px solid var(--BORDER-COLOR);
    border-bottom: 2px solid var(--BORDER-COLOR);
    padding: 1em 0;
}

.public__addr {
    margin-top: 1em;
}

.welcome a::before {
    content: "➜ "
}

/* || DASH HEADER, CONTAINER & FOOTER */

.dash-header {
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: var(--BGCOLOR);
    padding: 0 0.5em;
    border-bottom: 1px solid var(--BORDER-COLOR);
}

.dash-header__container {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
}

.dash-header__container--small {
    max-width: 800px;
}

.dash-header__nav {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    gap: 0.5em;
}

.dash-container {
    padding: 0.75em 0.5em 0.5em;
    flex-grow: 1;
}

.dash-footer {
    font-size: 1rem;
    position: sticky;
    bottom: 0;
    z-index: 1;
    background-color: var(--BGCOLOR);
    padding: 0.5em;
    border-top: 1px solid var(--BORDER-COLOR);
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    gap: 1em;
}

.dash-footer__button {
    font-size: 1rem;
    width: auto;
    height: auto;
}

/* || TABLES - GENERAL */

thead,
tbody,
tr {
    /*   display: contents; */
}

.table {
    font-size: 1rem;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    color: var(--TABLE-COLOR);
    gap: 0.1em;
}

.table__button {
    padding: 0.25em;
    font-size: 1.5rem;
    color: var(--TABLE-COLOR);
}

.table__thead {
    position: sticky;
    top: 0;
    z-index: 1;
}

.table__th,
.table__cell {
    background-color: var(--TABLE-BGCOLOR);
    text-align: left;
    border: 1px solid var(--TABLE-COLOR);
    padding: 0.5em;
}

.table__cell:last-child {
    display: grid;
    place-content: center;
}

.table__cell--inactive {
    background-color: var(--INACTIVE);
}

/* ||  NOTE */

.note__created,
.note__updated,
.note__username {
    display: none;
}

.note__status {
    font-weight: bold;
}

.note__status--open {
    color: var(--STATUS-OPEN);
}

.note__status--completed {
    color: var(--STATUS-COMPLETE);
}


/* || FORM - GENERAL */

.form {
    display: flex;
    flex-flow: column nowrap;
    gap: 0.75em;
    max-width: 800px;
}

.form__checkbox-container {
    display: flex;
    align-items: center;
    width: -moz-fit-content;
    width: fit-content;
    gap: 0.5em;
}

.form__persist {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 0.5em;
}

.form__title-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.form__input,
.form__submit-button {
    padding: 0.5em;
    border-radius: 15px;
}

.form__input--text {
    min-height: 150px;
}

.form__input--incomplete {
    border: 1px solid var(--INPUT-INVALID);
    outline: 1px solid var(--INPUT-INVALID);
}

.form__checkbox {
    width: 24px;
    height: 24px;
}

.form__select {
    border-radius: 15px;
    padding: 0.25em;
}

.form__action-buttons {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 0.5em;
    position: absolute;
    right: 0.5em;
}

.form__row {
    display: flex;
    flex-flow: row nowrap;
    gap: 2em;
}

.form__divider {
    display: flex;
    flex-flow: column nowrap;
    gap: 0.5em;
}

@media screen and (max-width: 400px) {
    h1 {
        font-size: 2rem;
    }

    .dash-header__nav {
        gap: 0;
    }

    .icon-button {
        font-size: 1.5rem;
    }
}


@media screen and (min-width: 768px) {

    body {
        font-size: 1.25rem;
    }

    .dash-header {
        padding: 0 1em;
    }

    .dash-container {
        padding: 1em;
    }

    .table {
        font-size: 1.5rem;
    }

    .table--notes {
        grid-template-columns: repeat(3, 1fr) 2fr repeat(2, 1fr);
    }

    .table--markets {
        grid-template-columns: 2fr 1fr 1fr;
    }

    .table--countries {
        grid-template-columns: 2fr 1fr 1fr;
    }

    .note__created,
    .note__updated,
    .note__username {
        display: block
    }

    .form__action-buttons {
        position: static;
    }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA,iBAAiB;;AAEjB;IACI,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;IACxB,sCAAsC;IACtC,yCAAyC;IACzC,4BAA4B;IAC5B,wBAAwB;IACxB,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,uBAAuB;AACvB;IACI,qBAAqB;IACrB,sCAAsC;IACtC,mBAAmB;IACnB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,6BAA6B;IAC7B,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,sBAAsB;;AAEtB;IACI,iCAAiC;IACjC,iBAAiB;IACjB,gCAAgC;IAChC,mBAAmB;IACnB,yDAA6C;IAC7C,sBAAsB;IACtB,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;;;;IAII,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA,aAAa;;AAEb;;IAEI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,yCAAyC;IACzC,4CAA4C;IAC5C,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;AACJ;;AAEA,uCAAuC;;AAEvC;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,gCAAgC;IAChC,gBAAgB;IAChB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,gCAAgC;IAChC,cAAc;IACd,yCAAyC;IACzC,aAAa;IACb,qBAAqB;IACrB,2BAA2B;IAC3B,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA,wBAAwB;;AAExB;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,kCAAkC;IAClC,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;;AAEA;;IAEI,sCAAsC;IACtC,gBAAgB;IAChB,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,iCAAiC;AACrC;;AAEA,aAAa;;AAEb;;;IAGI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;;AAGA,sBAAsB;;AAEtB;IACI,aAAa;IACb,wBAAwB;IACxB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,UAAU;AACd;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,MAAM;IACV;;IAEA;QACI,iBAAiB;IACrB;AACJ;;;AAGA;;IAEI;QACI,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wDAAwD;IAC5D;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;;;QAGI;IACJ;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Nunito&display=swap');\n\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n/* || VARIABLES */\n\n:root {\n    /* COLORS */\n    --BGCOLOR: #0F172A;\n    --BORDER-COLOR: #FFF;\n    --COLOR: #FFF;\n    --ERROR: firebrick;\n    --INACTIVE: lightgray;\n    --LINK-COLOR: whitesmoke;\n    --LINK-HOVER: rgba(245, 245, 245, 0.9);\n    --NOTE-BGCOLOR: hsla(240, 64%, 27%, 0.65);\n    --STATUS-COMPLETE: limegreen;\n    --STATUS-OPEN: firebrick;\n    --TABLE-BGCOLOR: #FFF;\n    --TABLE-COLOR: #000;\n    --INPUT-INVALID: #F00;\n}\n\n/* || UTILITY CLASSES */\n.errmsg {\n    display: inline-block;\n    background-color: var(--TABLE-BGCOLOR);\n    color: var(--ERROR);\n    padding: 0.25em;\n    margin-bottom: 0.5em;\n}\n\n.errmsg a:any-link {\n    color: var(--ERROR);\n    text-decoration: underline;\n}\n\n.nowrap {\n    white-space: nowrap;\n}\n\n.icon-button {\n    width: 48px;\n    height: 48px;\n    font-size: 2.4rem;\n    background-color: transparent;\n    border: none;\n    color: var(--COLOR);\n    display: inline;\n    place-content: center;\n}\n\n.icon-button:hover,\n.icon-button:focus-visible {\n    transform: scale(1.2);\n}\n\n.icon-button[disabled] {\n    visibility: hidden;\n}\n\n/* || GENERAL STYLES */\n\nbody {\n    font-family: 'Nunito', sans-serif;\n    min-height: 100vh;\n    background-color: var(--BGCOLOR);\n    color: var(--COLOR);\n    background-image: url('./img/background.jpg');\n    background-size: cover;\n    background-position: top right;\n    background-blend-mode: multiply;\n}\n\ninput,\nbutton,\ntextarea,\nselect {\n    font: inherit;\n}\n\n#root {\n    /* React root div */\n    min-height: 100vh;\n    display: flex;\n    flex-flow: column nowrap;\n}\n\na {\n    text-decoration: none;\n}\n\na:any-link {\n    color: var(--LINK-COLOR);\n}\n\na:hover,\na:focus-visible {\n    color: var(--LINK-HOVER);\n}\n\n/* || PAGES */\n\n.public,\n.welcome {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.public {\n    padding: 1em;\n    flex-grow: 1;\n}\n\n.public__main,\n.login {\n    flex-grow: 1;\n    border-top: 2px solid var(--BORDER-COLOR);\n    border-bottom: 2px solid var(--BORDER-COLOR);\n    padding: 1em 0;\n}\n\n.public__addr {\n    margin-top: 1em;\n}\n\n.welcome a::before {\n    content: \"➜ \"\n}\n\n/* || DASH HEADER, CONTAINER & FOOTER */\n\n.dash-header {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    background-color: var(--BGCOLOR);\n    padding: 0 0.5em;\n    border-bottom: 1px solid var(--BORDER-COLOR);\n}\n\n.dash-header__container {\n    display: flex;\n    flex-flow: row nowrap;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.dash-header__container--small {\n    max-width: 800px;\n}\n\n.dash-header__nav {\n    display: flex;\n    flex-flow: row nowrap;\n    justify-content: flex-end;\n    gap: 0.5em;\n}\n\n.dash-container {\n    padding: 0.75em 0.5em 0.5em;\n    flex-grow: 1;\n}\n\n.dash-footer {\n    font-size: 1rem;\n    position: sticky;\n    bottom: 0;\n    z-index: 1;\n    background-color: var(--BGCOLOR);\n    padding: 0.5em;\n    border-top: 1px solid var(--BORDER-COLOR);\n    display: flex;\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n    gap: 1em;\n}\n\n.dash-footer__button {\n    font-size: 1rem;\n    width: auto;\n    height: auto;\n}\n\n/* || TABLES - GENERAL */\n\nthead,\ntbody,\ntr {\n    /*   display: contents; */\n}\n\n.table {\n    font-size: 1rem;\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1fr 2fr 1fr;\n    color: var(--TABLE-COLOR);\n    gap: 0.1em;\n}\n\n.table__button {\n    padding: 0.25em;\n    font-size: 1.5rem;\n    color: var(--TABLE-COLOR);\n}\n\n.table__thead {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n}\n\n.table__th,\n.table__cell {\n    background-color: var(--TABLE-BGCOLOR);\n    text-align: left;\n    border: 1px solid var(--TABLE-COLOR);\n    padding: 0.5em;\n}\n\n.table__cell:last-child {\n    display: grid;\n    place-content: center;\n}\n\n.table__cell--inactive {\n    background-color: var(--INACTIVE);\n}\n\n/* ||  NOTE */\n\n.note__created,\n.note__updated,\n.note__username {\n    display: none;\n}\n\n.note__status {\n    font-weight: bold;\n}\n\n.note__status--open {\n    color: var(--STATUS-OPEN);\n}\n\n.note__status--completed {\n    color: var(--STATUS-COMPLETE);\n}\n\n\n/* || FORM - GENERAL */\n\n.form {\n    display: flex;\n    flex-flow: column nowrap;\n    gap: 0.75em;\n    max-width: 800px;\n}\n\n.form__checkbox-container {\n    display: flex;\n    align-items: center;\n    width: fit-content;\n    gap: 0.5em;\n}\n\n.form__persist {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    gap: 0.5em;\n}\n\n.form__title-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.form__input,\n.form__submit-button {\n    padding: 0.5em;\n    border-radius: 15px;\n}\n\n.form__input--text {\n    min-height: 150px;\n}\n\n.form__input--incomplete {\n    border: 1px solid var(--INPUT-INVALID);\n    outline: 1px solid var(--INPUT-INVALID);\n}\n\n.form__checkbox {\n    width: 24px;\n    height: 24px;\n}\n\n.form__select {\n    border-radius: 15px;\n    padding: 0.25em;\n}\n\n.form__action-buttons {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 0.5em;\n    position: absolute;\n    right: 0.5em;\n}\n\n.form__row {\n    display: flex;\n    flex-flow: row nowrap;\n    gap: 2em;\n}\n\n.form__divider {\n    display: flex;\n    flex-flow: column nowrap;\n    gap: 0.5em;\n}\n\n@media screen and (max-width: 400px) {\n    h1 {\n        font-size: 2rem;\n    }\n\n    .dash-header__nav {\n        gap: 0;\n    }\n\n    .icon-button {\n        font-size: 1.5rem;\n    }\n}\n\n\n@media screen and (min-width: 768px) {\n\n    body {\n        font-size: 1.25rem;\n    }\n\n    .dash-header {\n        padding: 0 1em;\n    }\n\n    .dash-container {\n        padding: 1em;\n    }\n\n    .table {\n        font-size: 1.5rem;\n    }\n\n    .table--notes {\n        grid-template-columns: repeat(3, 1fr) 2fr repeat(2, 1fr);\n    }\n\n    .table--markets {\n        grid-template-columns: 2fr 1fr 1fr;\n    }\n\n    .table--countries {\n        grid-template-columns: 2fr 1fr 1fr;\n    }\n\n    .note__created,\n    .note__updated,\n    .note__username {\n        display: block\n    }\n\n    .form__action-buttons {\n        position: static;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
